import { render, staticRenderFns } from "./ServiceProviderForm.vue?vue&type=template&id=4a1b734a&scoped=true"
import script from "./ServiceProviderForm.vue?vue&type=script&lang=js"
export * from "./ServiceProviderForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderForm.vue?vue&type=style&index=0&id=4a1b734a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b734a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VSelect,VTextField})
